import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  LayoutMain,
  Background,
  MainHeadline,
  TemplateOffer,
  Textsection,
  InfoOffer,
  NoOfferFound,
} from "../../components/common";
import { Divider } from "../../components/styles";
import { Row, Col } from "react-bootstrap";
import offers from "../../data/offersAvalanches";
import "./Avalanches.css";

const Avalanches = ({ headline = "SCHNEE" }) => {
  const baseImagePath = process.env.REACT_APP_BASE_IMAGE_PATH;
  const [selectedOffer, setSelectedOffer] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
	// clear offer selection whenever we land on the main page
	// (independent of load/unload):
	if (location.pathname === '/avalanches') {
		setSelectedOffer(null);
	}
  }, [location.pathname]);

  const handleOfferClick = (id) => {
    const selectedOffer = offers.find((offer) => offer.id === id);
    // add a (dummy) page to history stack to navigate back properly:
    navigate(`/avalanches/offer`);
    setSelectedOffer(selectedOffer);
  };

  const handleBookingClick = (id) => {
    navigate(`/avalanches`); // return here after navigating back from booking
    navigate(`/booking/${id}`);
  };

  const handleReturnClick = () => {
    navigate(`/avalanches`);
  };

  return (
    <LayoutMain>
      <Background image={`${baseImagePath}snow/background/img_aval1.jpg`}>
        <MainHeadline text={headline} />
      </Background>
      <Textsection>
        {!selectedOffer ? (
          <section className="avalanche-main">
            <div className="avalanche-wrapper">
              <div className="content-avalanche">
                <h2>
                  Schnee begeistert, fasziniert, lädt zum Spielen, Betrachten
                  und Erspüren ein{" "}
                </h2>
                <p>
                  kann aber auch zerstörerische Gewalt entwickeln und Familien
                  oder ganze Ortschaften zerstören. Selten liegen vollkommenes
                  Glück und tiefgreifendes Leid so nahe beisammen wie bei
                  Tiefschneefahren und Lawine. Die Komplexität der Materie macht
                  es uns dabei so schwer, im Vorhinein die Trennlinie zu ziehen.
                  Man kann nur versuchen durch lebenslanges Lernen, exakte
                  Vorbereitung, taktische Maßnahmen und gute Intuition möglichst
                  sicher möglichst viel Freude zu erlangen.
                </p>
                <h3>
                  Bei KaMikaze Travel sind wir der Meinung dass das
                  längerfristig - also über ein gesamtes Bergsteigerleben - nur
                  durch ein möglichst allumfängliches Bild und fundierte
                  Ausbildung in verschiedenen Facetten möglich ist.
                </h3>
                <p>
                  Dazu gehört ein solides Verständnis der amtlichen
                  Lawinenprognose, wissens- und regelbasierte Schnee- und
                  Lawinenkunde, Taktik und Spurwahl, physikalische Prozesse in
                  der Schneedecke und Atmosphäre, der Notfall Lawine samt
                  medizinischer Betreuung, Kenntnis der Besonderheiten der
                  heimischen Berge, und nicht zuletzt ein ehrliches
                  Risikobewusstsein.
                </p>

                <p>
                  Unsere Lawinentage sind hierbei ein gutes Mittel um flexibel
                  und individuell die eigenen Fähigkeiten in einem oder mehreren
                  dieser Bereiche aufzubessern.
                </p>
              </div>

              <Divider text="Angebote" />

              <div className="avalanche-offer">
                <Row>
                  {offers.map((offers) => (
                    <Col key={offers.id} xs={12} sm={6} md={4}>
                      <TemplateOffer
                        imgHead={offers.imgHead}
                        title={offers.title}
                        subtitle={offers.subtitle}
                        text={offers.text_overview}
                        price={offers.price}
                        duration={offers.duration}
                        maxGuests={offers.maxGuests}
                        overalleLevel={offers.overalleLevel}
                        onMehrClick={() => handleOfferClick(offers.id)}
                        onBuchenClick={() => handleBookingClick(offers.id)}
                      />
                    </Col>
                  ))}
                </Row>
              </div>
            </div>
          </section>
        ) : (
          <section className="info-offer-section">
            <InfoOffer
              offers={selectedOffer}
              onReturn={handleReturnClick}
              onBook={handleBookingClick}
            />
          </section>
        )}
      </Textsection>

      <NoOfferFound
        heading="Kein passendes Angebot gefunden?"
        description="Kein Problem! Wir planen gerne eine individuelle und einzigartige Reise oder Tour, die ganz auf deine Wünsche zugeschnitten ist. Lass uns deine Vorstellungen wissen, und wir erstellen das perfekte Reiseerlebnis für dich."
        buttonText="Schreib uns!"
        buttonLink="/contact"
      />
    </LayoutMain>
  );
};

export default Avalanches;
